import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { roleHome } from "../lib/roleRedirect";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    // clean URL immediately
    window.history.replaceState(null, "", window.location.pathname);

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const data = await api.emergentSession(sessionId);
        setUser(data.user);
        navigate(roleHome(data.user), { replace: true, state: { user: data.user } });
      } catch (err) {
        console.error("Emergent session exchange failed", err);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#FDFBF7]" data-testid="auth-callback">
      <div className="text-center">
        <div className="inline-block h-10 w-10 rounded-full border-4 border-[#4361EE] border-t-transparent animate-spin" />
        <p className="mt-4 text-black/60 font-semibold">Signing you in…</p>
      </div>
    </div>
  );
}
